import { useQuery, queryOptions } from '@tanstack/react-query';
import { QueryConfig } from '@/lib/api-clients/react-query';
import { AccountResponse } from '@/types/api';
import { AuthParams, useAccountStore } from '@/store/use-account-store';
import { privateApi } from '@/lib/api-clients/rest-client';
import { useUnifiedAccount } from '@/hooks';
import { handleAccountForStore } from '@/utils/handle-store-data';

// export const fetchAccountInputSchema = z.object({
//   nonce: z.number(),
//   signature: z.string(),
// });

// export type FetchAccountInput = z.infer<typeof fetchAccountInputSchema>;

export const fetchAccount = async (): Promise<AccountResponse> => {
  return privateApi
    .get<AccountResponse>('/account', {
      params: {},
    })
    .then((res) => {
      handleAccountForStore(res);
      return res;
    });
};

export const getAccountQueryOptions = (
  authParams: AuthParams | undefined,
  address: string | undefined,
) => {
  return queryOptions({
    queryKey: ['account', address, authParams?.signingKey], // temp: invalidate cache some other way?
    queryFn: () => fetchAccount(),
  });
};

type UseFetchAccountOptions = {
  queryConfig?: QueryConfig<typeof fetchAccount>;
};

export const useFetchAccount = ({
  queryConfig,
  ...params
}: UseFetchAccountOptions = {}) => {
  const { address } = useUnifiedAccount();
  const { hasAuth, authParams } = useAccountStore((state) => ({
    hasAuth: state.hasAuth,
    authParams: state.getAuthParams(),
  }));

  const result = useQuery({
    enabled: hasAuth && !!address && !!authParams?.signingKey,
    ...getAccountQueryOptions(authParams, address),
    ...queryConfig,
  });

  return result;
};
